import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { SERVICES } from "../../data/staticData";

export default function ServicesGrid() {
  return (
    <section id="services" className="py-24 sm:py-32" data-testid="services-grid-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-12 items-end">
          <div className="lg:col-span-7">
            <div className="eyebrow mb-4">What we deliver</div>
            <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-tight">
              Eight services. One quiet workspace.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-inkSoft text-lg leading-relaxed">
              Every service is productized: clear scope, fixed turnaround, and white-label reporting. Mix link building with digital PR and on-page work, and scale up when you need to.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.slug}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ delay: (i % 4) * 0.06, duration: 0.5, ease: [0.25, 1, 0.5, 1] }}
              >
                <Link
                  to={`/services/${s.slug}`}
                  className="card-soft p-6 h-full block group relative"
                  data-testid={`service-card-${s.slug}`}
                >
                  <div className="flex items-center justify-between mb-5">
                    <div className="h-11 w-11 rounded-xl bg-surfaceAlt grid place-items-center text-terra group-hover:bg-terra group-hover:text-white transition">
                      <Icon size={20} strokeWidth={1.8} />
                    </div>
                    <ArrowUpRight size={16} className="text-inkSoft group-hover:text-terra transition" />
                  </div>
                  <h3 className="font-display text-lg font-semibold tracking-tight mb-2">{s.title}</h3>
                  <p className="text-sm text-inkSoft leading-relaxed line-clamp-3">{s.short}</p>
                  <div className="mt-5 pt-4 border-t border-line flex items-center justify-between">
                    <span className="text-xs text-inkSoft">From</span>
                    <span className="font-mono font-semibold">${s.starting_price}</span>
                  </div>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
